import { BaseModel } from "sjs-base-model";

export default class TaegTegModel extends BaseModel {
    public readonly teg: number | undefined = undefined;
    public readonly taeg: number | undefined = undefined;

    constructor(data: Partial<TaegTegModel>) {
        super();

        this.update(data);
    }
}
